const CHANNEL_NAME = "performance-tracker";

export function createTrackerChannel(onMessage) {
  if (typeof BroadcastChannel === "undefined") {
    return { post() {}, close() {} };
  }

  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.onmessage = (event) => {
    if (event?.data) onMessage(event.data);
  };

  return {
    post(message) {
      try {
        channel.postMessage(message);
      } catch {
        /* channel may already be closed */
      }
    },
    close() {
      try {
        channel.close();
      } catch {
        /* ignore */
      }
    },
  };
}
